import React from "react";

interface Props {
  children: React.ReactNode;
}

const MetadataModalBody = ({ children }: Props) => {
  return <div className="metadata-modal-body">{children}</div>;
};

export default React.memo(MetadataModalBody);
